import {RentalVehicleOrderResponseBody, RentalVehicleResponseBody} from '@dms/api/vehicle';

import {Nullish, parseDate} from 'shared/web';

export function getActiveRentalOrder(
  rentalVehicle?: RentalVehicleResponseBody
): RentalVehicleOrderResponseBody | Nullish {
  if (!rentalVehicle) {
    return null;
  }

  const today = new Date();
  const lastOrder = rentalVehicle?.lastRentalOrder;
  const upcomingOrder = rentalVehicle?.upcomingRentalOrder;

  if (
    lastOrder?.rentalPeriodFrom &&
    lastOrder?.rentalPeriodTo &&
    parseDate(lastOrder.rentalPeriodFrom) <= today &&
    parseDate(lastOrder.rentalPeriodTo) >= today
  ) {
    return lastOrder;
  }

  if (upcomingOrder) {
    return upcomingOrder;
  }

  return lastOrder ?? null;
}
